import React from 'react';
import Badge from '@mui/material/Badge';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import type { CartFabProps } from '../types';

const CartFab: React.FC<CartFabProps> = ({ itemCount, grandTotal, hasCost, onOpen }) => {
    return (
        <button className="posv2-fab" onClick={onOpen} aria-label="Open cart">
            <Badge badgeContent={itemCount} color="error">
                <ShoppingCartIcon />
            </Badge>
            {hasCost && <span className="posv2-fab__total">₹{grandTotal}</span>}
        </button>
    );
};

export default React.memo(CartFab);
